var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDriverLicense = function SvgDriverLicense(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 15.6667H16.4167C16.5714 15.6667 16.7197 15.6052 16.8291 15.4958C16.9385 15.3864 17 15.238 17 15.0833V8.66667H15.8333L13.654 4.34642C13.6081 4.24331 13.5334 4.1557 13.4388 4.09421C13.3442 4.03273 13.2337 4 13.1209 4H6.87909C6.76626 4 6.65584 4.03273 6.56123 4.09421C6.46661 4.1557 6.39186 4.24331 6.34604 4.34642L4.16667 8.66667H3V15.0833C3 15.238 3.06146 15.3864 3.17085 15.4958C3.28025 15.6052 3.42862 15.6667 3.58333 15.6667H5.33333C5.48804 15.6667 5.63642 15.6052 5.74581 15.4958C5.85521 15.3864 5.91667 15.238 5.91667 15.0833V13.3333H14.0833V15.0833C14.0833 15.238 14.1448 15.3864 14.2542 15.4958C14.3636 15.6052 14.512 15.6667 14.6667 15.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.66666L3 8.66667",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
};
export default SvgDriverLicense;